module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "my-4"
  }, [_c('document-type-header', {
    attrs: {
      "title": _vm.$t('iframe_page.doctypes.id'),
      "statusLabel": _vm.statusLabel,
      "statusIcon": _vm.statusIcon,
      "subTitle": _vm.subTitle
    }
  }, [_vm._v("\n    " + _vm._s(_vm.$t('iframe_page.docinfo.id_1')) + " "), _c('br'), _vm._v("  " + _vm._s(_vm.$t('iframe_page.docinfo.id_2')) + " "), _c('br'), _vm._v(" " + _vm._s(_vm.$t('iframe_page.docinfo.id_3')) + "  "), _c('br'), _vm._v(" " + _vm._s(_vm.$t('iframe_page.docinfo.id_4')) + " "), _c('br'), _vm._v(" " + _vm._s(_vm.$t('iframe_page.docinfo.id_5')) + "\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "mt-2 form-group"
  }, [_c('multiple-documents-upload', {
    attrs: {
      "multiple": "",
      "canAdd": _vm.canAdd,
      "canDelete": _vm.canDelete,
      "canReplace": _vm.canReplace,
      "id": _vm.$options.name,
      "hasError": _vm.fileHasError,
      "errorMsg": _vm.$t('errors.invalid_id')
    },
    on: {
      "resetError": function($event) {
        _vm.fileHasError = false
      },
      "filesUploaded": _vm.resetStatut
    },
    model: {
      value: (_vm.uploadedFiles),
      callback: function($$v) {
        _vm.uploadedFiles = $$v
      },
      expression: "uploadedFiles"
    }
  })], 1), _vm._v(" "), (_vm.showBtnValidate) ? _c('div', {
    staticClass: "my-4"
  }, [_c('button', {
    staticClass: "validation-btn LMSG-background-color",
    attrs: {
      "type": "button",
      "disabled": !_vm.canValidate || _vm.showLoader
    },
    on: {
      "click": function($event) {
        return _vm.validateButton()
      }
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t('creation_forms.vldt')) + "\n    ")])]) : _vm._e()], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-c97abaa0", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c97abaa0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/LMSGiframe/components/DocumentPiV2.vue
// module id = 2505
// module chunks = 2